import React from 'react';

const STYLES = {
  CLEAR: 'bg-green-50 text-green-700 border-green-200',
  CLEAR_WITH_CONDITION: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  REGIONAL: 'bg-amber-50 text-amber-700 border-amber-200',
  HOLD: 'bg-red-50 text-red-700 border-red-200',
  VERIFY: 'bg-orange-50 text-orange-700 border-orange-200',
  NO_TEXT: 'bg-gray-100 text-gray-600 border-gray-200',
};

const RightsBadge = ({ verdict }) => (
  <span className={`text-[9px] font-bold uppercase tracking-wider border rounded-full px-2 py-0.5 ${STYLES[verdict] || STYLES.NO_TEXT}`}>
    {verdict ? verdict.replace(/_/g, ' ') : 'No record'}
  </span>
);

export default RightsBadge;